import { Component, Input, OnInit } from '@angular/core';
import { CustomSiteService } from '../services/customsite.service';

@Component({
  selector: 'app-whatsapp-button',
  templateUrl: './whatsapp-button.component.html',
  styleUrls: ['./whatsapp-button.component.css']
})
export class WhatsappButtonComponent implements OnInit {
  @Input() whatsappLink: string;
  agencia: string;


  constructor(private customSiteService: CustomSiteService) { }

  ngOnInit() {
    this.agencia = localStorage.getItem('agency');
    this.customSiteService.whatsapp(this.agencia.toString()).subscribe(
      response => {
        this.whatsappLink = response;
      },
      error => {
        console.error('Erro na chamada do serviço Whatsapp:', error);
      }
    );
  }

  onConfigLoad(config) {
    this.agencia = config.agencyId
  }
}
